var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout__controls" },
        [
          _c("div", { staticClass: "form-inline" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "form",
                {
                  attrs: {
                    method: "post",
                    enctype: "multipart/form-data",
                    action: _vm.urlImportacion
                  }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: "_token", id: "_token" },
                    domProps: { value: _vm.token }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.searchButton &&
                      (_vm.permiteEditarItem || _vm.permiteEliminarItem),
                    expression:
                      "searchButton && (permiteEditarItem || permiteEliminarItem)"
                  }
                ],
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.buscarItems }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Buscar ítems")])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                height: "auto",
                width: "70%",
                scrollable: "",
                name: "listaItems"
              }
            },
            [
              _c("lista-item", {
                attrs: { createButton: _vm.createButton },
                on: { selected: _vm.selectedItem }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c("div", { staticClass: "layout__main-form" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__title" }, [
            _c("h5", [_vm._v("Información del ítem")]),
            _vm._v(" "),
            _c("div", { staticClass: "card__controls" }, [
              _c(
                "label",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tipoProducto === "T",
                      expression: "tipoProducto === 'T'"
                    }
                  ],
                  attrs: { for: "producto" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_item,
                        expression: "form.tipo_item"
                      }
                    ],
                    attrs: { type: "radio", id: "producto", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.tipo_item, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_item", "P")
                      }
                    }
                  }),
                  _c("span", [_vm._v("Producto")])
                ]
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tipoProducto === "T",
                      expression: "tipoProducto === 'T'"
                    }
                  ],
                  attrs: { for: "servicio" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_item,
                        expression: "form.tipo_item"
                      }
                    ],
                    attrs: { type: "radio", id: "servicio", value: "S" },
                    domProps: { checked: _vm._q(_vm.form.tipo_item, "S") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_item", "S")
                      }
                    }
                  }),
                  _c("span", [_vm._v("Servicio")])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { id: "codigo", placeholder: "Código interno" },
                        model: {
                          value: _vm.form.codigo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "codigo", $$v)
                          },
                          expression: "form.codigo"
                        }
                      },
                      [
                        _c("span", [_vm._v("Código *")]),
                        _vm._v(" "),
                        _vm.errores.codigo
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.codigo[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("p", [
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tipo === "T",
                          expression: "tipo === 'T'"
                        }
                      ],
                      attrs: { for: "radioEmpresa" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo,
                            expression: "form.tipo"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "radioEmpresa",
                          value: "E"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipo, "E") },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.form, "tipo", "E")
                          }
                        }
                      }),
                      _c("span", [_vm._v("Item local")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tipo === "T",
                          expression: "tipo === 'T'"
                        }
                      ],
                      attrs: { for: "radioProveedor" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo,
                            expression: "form.tipo"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "radioProveedor",
                          value: "P"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipo, "P") },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.form, "tipo", "P")
                          }
                        }
                      }),
                      _c("span", [_vm._v("Item de proveedor")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _vm.form.tipo == "E"
                      ? _c(
                          "input-field",
                          {
                            attrs: {
                              id: "id_auxiliar",
                              placeholder: "Ingrese código SRI"
                            },
                            model: {
                              value: _vm.form.id_auxiliar,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "id_auxiliar", $$v)
                              },
                              expression: "form.id_auxiliar"
                            }
                          },
                          [
                            _c("span", [_vm._v("Código SRI")]),
                            _vm._v(" "),
                            _vm.errores.id_auxiliar
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.errores.id_auxiliar[0]) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { id: "nombre", placeholder: "Nombre del ítem" },
                        model: {
                          value: _vm.form.nombre,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "nombre", $$v)
                          },
                          expression: "form.nombre"
                        }
                      },
                      [
                        _c("span", [_vm._v("Nombre *")]),
                        _vm._v(" "),
                        _vm.errores.nombre
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.nombre[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "descripcion",
                          placeholder: "Descripción del ítem"
                        },
                        model: {
                          value: _vm.form.descripcion,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "descripcion", $$v)
                          },
                          expression: "form.descripcion"
                        }
                      },
                      [
                        _c("span", [_vm._v("Descripción")]),
                        _vm._v(" "),
                        _vm.errores.descripcion
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.descripcion[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.categorias,
                          label: "nombre",
                          id: "categoria",
                          placeholder: "Seleccione..."
                        },
                        model: {
                          value: _vm.selectedCategoria,
                          callback: function($$v) {
                            _vm.selectedCategoria = $$v
                          },
                          expression: "selectedCategoria"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "categoria" } }, [
                        _vm._v("Categoría *")
                      ]),
                      _vm._v(" "),
                      _vm.errores.id_categoria
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.errores.id_categoria[0]) +
                                  "\n                  "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_item === "P",
                      expression: "form.tipo_item === 'P'"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-4"
                },
                [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.marcas,
                            label: "nombre",
                            id: "marca",
                            placeholder: "Seleccione..."
                          },
                          model: {
                            value: _vm.selectedMarca,
                            callback: function($$v) {
                              _vm.selectedMarca = $$v
                            },
                            expression: "selectedMarca"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "marca" } }, [
                          _vm._v("Marca")
                        ]),
                        _vm._v(" "),
                        _vm.errores.id_marca
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.id_marca[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.tarifasIva,
                          label: "nombre",
                          id: "iva",
                          placeholder: "Seleccione..."
                        },
                        model: {
                          value: _vm.selectedIva,
                          callback: function($$v) {
                            _vm.selectedIva = $$v
                          },
                          expression: "selectedIva"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "iva" } }, [
                        _vm._v("Tarifa IVA *")
                      ]),
                      _vm._v(" "),
                      _vm.errores.iva_id
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.errores.iva_id[0]) +
                                  "\n                  "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.money2,
                          id: "precio_produccion",
                          placeholder: "Precio de producción o aduana"
                        },
                        model: {
                          value: _vm.form.precio_produccion,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "precio_produccion", $$v)
                          },
                          expression: "form.precio_produccion"
                        }
                      },
                      [
                        _c("span", [_vm._v("Precio de producción (ICE)")]),
                        _vm._v(" "),
                        _vm.errores.precio_produccion
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.precio_produccion[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.decimal,
                          id: "cantidad_ice",
                          placeholder: "##"
                        },
                        model: {
                          value: _vm.form.cantidad_ice,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cantidad_ice", $$v)
                          },
                          expression: "form.cantidad_ice"
                        }
                      },
                      [
                        _c("span", [_vm._v("Cantidad gravada (ICE)")]),
                        _vm._v(" "),
                        _vm.errores.cantidad_ice
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.cantidad_ice[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.tarifasIce,
                          label: "nombre",
                          id: "ice",
                          placeholder: "Seleccione..."
                        },
                        model: {
                          value: _vm.selectedIce,
                          callback: function($$v) {
                            _vm.selectedIce = $$v
                          },
                          expression: "selectedIce"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "ice" } }, [
                        _vm._v("Tarifa ICE")
                      ]),
                      _vm._v(" "),
                      _vm.errores.ice_id
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.errores.ice_id[0]) +
                                  "\n                  "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c("p", [
                    _c("label", { attrs: { for: "iva_incluido_precio" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.iva_incluido_precio,
                            expression: "form.iva_incluido_precio"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "iva_incluido_precio",
                          id: "iva_incluido_precio"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.iva_incluido_precio)
                            ? _vm._i(_vm.form.iva_incluido_precio, null) > -1
                            : _vm.form.iva_incluido_precio
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.iva_incluido_precio,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "iva_incluido_precio",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "iva_incluido_precio",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "iva_incluido_precio", $$c)
                            }
                          }
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          "El precio ya incluye IVA en caso de gravar el impuesto"
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.money2,
                          id: "precio",
                          placeholder: "Precio unitario"
                        },
                        model: {
                          value: _vm.form.precio_venta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "precio_venta", $$v)
                          },
                          expression: "form.precio_venta"
                        }
                      },
                      [
                        _c("span", [_vm._v("Precio de venta *")]),
                        _vm._v(" "),
                        _vm.errores.precio_venta
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.precio_venta[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.money2,
                          id: "costo",
                          placeholder: "Costo unitario"
                        },
                        model: {
                          value: _vm.form.costo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "costo", $$v)
                          },
                          expression: "form.costo"
                        }
                      },
                      [
                        _c("span", [_vm._v("Costo *")]),
                        _vm._v(" "),
                        _vm.errores.costo
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.costo[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.money2,
                          id: "precio",
                          placeholder: "$ ##.##"
                        },
                        model: {
                          value: _vm.form.valor_subsidio,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "valor_subsidio", $$v)
                          },
                          expression: "form.valor_subsidio"
                        }
                      },
                      [
                        _c("span", [_vm._v("Valor subsidiado *")]),
                        _vm._v(" "),
                        _vm.errores.valor_subsidio
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.valor_subsidio[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.irbpnr,
                      expression: "form.irbpnr"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-4"
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.decimal,
                            id: "precio",
                            placeholder: "IRBPNR"
                          },
                          model: {
                            value: _vm.form.cantidad_irbpnr,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cantidad_irbpnr", $$v)
                            },
                            expression: "form.cantidad_irbpnr"
                          }
                        },
                        [
                          _c("span", [_vm._v("Cantidad IRBPNR")]),
                          _vm._v(" "),
                          _vm.errores.cantidad_irbpnr
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.errores.cantidad_irbpnr[0]) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c("label", { attrs: { for: "irbpnr" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.irbpnr,
                          expression: "form.irbpnr"
                        }
                      ],
                      attrs: { type: "checkbox", id: "irbpnr" },
                      domProps: {
                        checked: Array.isArray(_vm.form.irbpnr)
                          ? _vm._i(_vm.form.irbpnr, null) > -1
                          : _vm.form.irbpnr
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.form.irbpnr,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.form, "irbpnr", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "irbpnr",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "irbpnr", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("IRBPNR")])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-2" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.estado !== "N",
                  expression: "estado !== 'N'"
                }
              ],
              staticClass: "col-xs-12 col-md-6"
            },
            [
              _c("div", { staticClass: "card" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c(
                    "form",
                    {
                      attrs: {
                        action: _vm.url + "/items/subir-foto",
                        method: "POST",
                        enctype: "multipart/form-data"
                      }
                    },
                    [
                      _c("center", [
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: "_token",
                            id: "_token"
                          },
                          domProps: { value: _vm.token }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "id", id: "id" },
                          domProps: { value: _vm.form.id }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("input", {
                            attrs: { type: "file", name: "foto", id: "foto" },
                            on: { change: _vm.changeFoto }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-success",
                              attrs: { type: "button" },
                              on: { click: _vm.subirFoto }
                            },
                            [
                              _c("i", { staticClass: "fa fa-upload" }),
                              _c("span", [_vm._v("Subir foto")])
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("center", [
                        _c("img", {
                          attrs: {
                            src: _vm.urlImagen,
                            id: "imagen",
                            alt: "Imagen",
                            width: "50%"
                          }
                        })
                      ])
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card__content" },
                [
                  _c("precios", {
                    attrs: { errores: _vm.errores },
                    model: {
                      value: _vm.form.precios,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "precios", $$v)
                      },
                      expression: "form.precios"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.permiteCrearItem && _vm.estado === "N") ||
                      (_vm.permiteEditarItem && _vm.estado !== "N"),
                    expression:
                      "(permiteCrearItem && estado === 'N') || (permiteEditarItem && estado !== 'N')"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.guardarItem }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(" "),
                _c("span", [_vm._v("Guardar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.permiteCrearItem,
                    expression: "permiteCrearItem"
                  }
                ],
                staticClass: "btn-secondary btn--text",
                attrs: { type: "button" },
                on: { click: _vm.crearItem }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _c("span", [_vm._v("Nuevo")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A" && _vm.permiteEliminarItem,
                    expression: "estado === 'A' && permiteEliminarItem"
                  }
                ],
                staticClass: "btn-danger btn--text",
                attrs: { type: "button" },
                on: { click: _vm.eliminarItem }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _vm._v(" "),
                _c("span", [_vm._v("Eliminar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "I" && _vm.permiteEliminarItem,
                    expression: "estado === 'I' && permiteEliminarItem"
                  }
                ],
                staticClass: "btn-success btn--text",
                attrs: { type: "button" },
                on: { click: _vm.eliminarItem }
              },
              [
                _c("i", { staticClass: "fa fa-power-off" }),
                _vm._v(" "),
                _c("span", [_vm._v("Re-activar")])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Ítem")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-inline" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("input", { attrs: { type: "file", name: "archivo", id: "archivo" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("button", { staticClass: "btn-success" }, [
          _c("i", { staticClass: "fa fa-upload" }),
          _c("span", [_vm._v("Importar")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Foto")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Precios")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-722cbdc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722cbdc2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/items/Item.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-722cbdc2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/items/Item.vue
// module chunks = 0